import { LogOut } from 'lucide-react';

import { clearBearerToken } from '@/common/axios';
import { ROUTE_LOGIN } from '@/common/constants';
import { IUser } from '@/common/models';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar.tsx';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const LayoutSidebarUser: FC<{ user: IUser; open: boolean }> = ({
  user,
  open,
}) => {
  const userName = `${user?.first_name} ${user?.last_name}`;
  const navigate = useNavigate();

  const logOut = () => {
    clearBearerToken();
    navigate(ROUTE_LOGIN);
  };

  const { t } = useTranslation();
  return (
    <SidebarMenu>
      <SidebarMenuItem className={'mb-4'}>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="flex items-center justify-center "
            >
              <Avatar>
                <AvatarFallback className="font-semibold">
                  {(user?.first_name?.charAt(0) || '') +
                    (user?.last_name?.charAt(0) || '')}
                </AvatarFallback>
              </Avatar>
              {open && (
                <div className="grid flex-1 text-left text-sm text-white leading-tight">
                  <span className="truncate text-xs font-medium text-white">
                    {userName}
                  </span>
                  <span className="truncate text-xs text-white/60">
                    {user?.username || ''}
                  </span>
                </div>
              )}
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg "
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <div className="grid flex-1 text-left text-sm leading-tight space-y-1">
                  <span className="font-medium text-xs">{userName}</span>
                  <span className="truncate text-xs">{user.inn}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className={'cursor-pointer'}
              onClick={() => logOut()}
            >
              <LogOut />
              {t('logout')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
